import { Component, defineComponent } from '@decify/cell-shopify/client';
import { Rating, ratingTagName } from '../Rating';
import './RatingReviewsIO.scss';
export const ratingReviewsIOName = 'RatingReviewsIO';
export const ratingReviewsIOTagName = 'cell-component-rating-reviews-io';
export class RatingReviewsIO extends Component {
    constructor() {
        super(ratingReviewsIOName);
        this.fetchRating = this.fetchRating.bind(this);
    }
    componentDidMount() {
        // If no store ID is provided, show the rating data set in the theme editor.
        if (!this.props.storeId) {
            this.ratingComponent.showSkeleton(false);
            return;
        }
        if (document.readyState === 'complete') {
            this.fetchRating();
        }
        else {
            window.addEventListener('load', this.fetchRating);
        }
    }
    async fetchRating() {
        const response = await fetch(`https://api.reviews.io/merchant/reviews?store=${this.props.storeId}`);
        const responseData = await response.json();
        const { stats } = responseData;
        const rating = Number(stats.average_rating);
        const ratingCount = Number(stats.total_reviews);
        this.ratingComponent.update({ rating, ratingCount });
        this.ratingComponent.showSkeleton(false);
    }
    get ratingComponent() {
        const ratingElement = this.querySelector(ratingTagName);
        if (!ratingElement || !(ratingElement instanceof Rating)) {
            throw new Error('Rating component not found');
        }
        return ratingElement;
    }
}
defineComponent(ratingReviewsIOTagName, RatingReviewsIO);
